import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, resolveComponent as _resolveComponent } from "vue"

import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel';
import { Direction, SegmentEnd } from '@/logic/_infra/_tech'
import { Timespending } from '@/app.context/workspace/Event'
import TimelineClocksComponent from './TimelineClocksComponent.vue'
import TimelineFullSubClocksComponent from './TimelineFullSubClocksComponent.vue'
import TimelineSimpleSubClocksComponent from './TimelineSimpleSubClocksComponent.vue'
import ZeroTimeffortComponent from './ZeroTimeffortComponent_Timeline.vue'
import TimeffortIcon from './TimeffortIconComponent_Timeline.vue'
import TimeffortText from './TimeffortTextComponent_Timeline.vue'
import TimespendingComponent from './Timespending_Timeline.vue'
import EffortTextComponent from './EffortTextComponent.vue'
import { computed } from 'vue';



//const props = defineProps<{ item: EffortRmodel, x:boolean | undefined }>()

export default /*#__PURE__*/_defineComponent({
  __name: 'EffortComponent_Timeline',
  props: {
    item: {},
    offset: {}
  },
  emits: {
    "click"(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

        return true
    }
},
  setup(__props: any, { emit: __emit }) {


const props = __props

//const props = defineProps<{ item: EffortRmodel, hideClock?:boolean}>()

const emit = __emit

const offset = computed(()=>{

    if (props.offset == undefined){

        return null
    }
    else return props.offset
})

function click(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

    emit("click", d, e, effort, timeffort, timespending)
}

// const simpleClock = computed(()=>{

//     if (props.x == undefined) return false

//     return props.x!
// })


return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_ctx.item.meffort != null)
    ? (_openBlock(), _createBlock(EffortTextComponent, {
        key: 0,
        item: _ctx.item.meffort.objects,
        minutes: _ctx.item.segment_value.timespan_min
      }, null, 8, ["item", "minutes"]))
    : (_ctx.item.timeffort != null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(TimeffortText, {
            item: _ctx.item.timeffort,
            span: _ctx.item.span_min
          }, null, 8, ["item", "span"]),
          _createVNode(TimeffortIcon, {
            item: _ctx.item.timeffort,
            resolution: _ctx.item.resolution
          }, null, 8, ["item", "resolution"])
        ], 64))
      : (_ctx.item.isTimespending_Single())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(TimespendingComponent, {
              item: _ctx.item.timespendings[0].ref,
              offset: offset.value
            }, null, 8, ["item", "offset"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.timefforts_zeros, (s) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "subline",
                key: s[0].toString()
              }, [
                _createVNode(TimelineSimpleSubClocksComponent, {
                  item: _ctx.item,
                  timepoint: s[0],
                  timeffort: s[1],
                  onClick: click,
                  edge: 'E',
                  offset: offset.value
                }, null, 8, ["item", "timepoint", "timeffort", "offset"]),
                _createVNode(ZeroTimeffortComponent, {
                  item: s[1]
                }, null, 8, ["item"])
              ]))
            }), 128))
          ], 64))
        : (_ctx.item.isTimespending_Multiple())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.timespendings, (s, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subline",
                  key: i
                }, [
                  _createVNode(TimelineFullSubClocksComponent, {
                    item: _ctx.item,
                    segment: s.segment,
                    timeffort: null,
                    timespending: s.ref,
                    offset: offset.value,
                    onClick: click
                  }, null, 8, ["item", "segment", "timespending", "offset"]),
                  _createVNode(TimespendingComponent, {
                    item: s.ref,
                    offset: offset.value
                  }, null, 8, ["item", "offset"])
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.timefforts_zeros, (s) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "subline",
                  key: s[0].toString()
                }, [
                  _createVNode(TimelineSimpleSubClocksComponent, {
                    item: _ctx.item,
                    timepoint: s[0],
                    timeffort: s[1],
                    onClick: click,
                    edge: 'E',
                    offset: offset.value
                  }, null, 8, ["item", "timepoint", "timeffort", "offset"]),
                  _createVNode(ZeroTimeffortComponent, {
                    item: s[1]
                  }, null, 8, ["item"])
                ]))
              }), 128))
            ], 64))
          : (_openBlock(), _createBlock(_component_Error, { key: 4 }))
}
}

})